import axios from "axios";
import { CLIENT_LIST_FAIL, CLIENT_LIST_REQUEST, CLIENT_LIST_SUCCESS } from "../constats/client.constant";
import { endpointApi } from "../../utils";
import { logout } from "./auth.action";

export const getClients = (location=null, navigate=null) => async(dispatch) => {
    try {
        const jwt_access = localStorage.getItem('jwt_access');
        dispatch({
            type: CLIENT_LIST_REQUEST
        });
        const { data } = await axios.get(`${ endpointApi }clients${ location ? location.search : "" }`, {
            headers: {
                'Authorization': `Bearer ${ jwt_access }`
            }
        });
        dispatch({
            type: CLIENT_LIST_SUCCESS,
            payload: data
        });
    } catch (err) {
        if(err.response.status === 401){
            dispatch({
                type: CLIENT_LIST_FAIL,
                payload: null
            });
            const url = location ? location.pathname + location.search : null;
            dispatch(logout(url, navigate));
        }else{
            dispatch({
                type: CLIENT_LIST_FAIL,
                payload: err.response && err.response.data && err.response.data.message ? err.response.data.message : err.message
            });
        }
    }
}